import React from 'react'
import { Bar, BarChart, ResponsiveContainer } from 'recharts'

import LineSkeleton from '../../Mantine/Skeleton/line'
import GraficoHistoricoConsumo from '../GraficoConsumoCiclo'
import Alerta from '../GraficoConsumoCiclo/Alerta'

import ApexChartConsumo from './ApexChartConsumo'
import CardHeader from './CardHeader'
import LinhaLegendaConsumo from './LinhaLegendaConsumo'

export default function GraficoSimcardsConsumoCiclo({
  portalCliente,
  handleAbrirMenuOpcoes,
  revelarOpcoesConsumo,
  menuElement,
  cdPlano,
  showHistoricoConsumo,
  chartConsumoData,
  chartFillColors,
  valueTotals,
  consumoNoCicloDash,
  loadingDash,
  dataHistoricoConsumo,
  tooltipTotalContratado,
  tooltipTotalAtivo,
  tooltipPrevisaoConsumo,
  tooltipConsumoTotal,
  filtroOperadora,
  filtroOperadoraPlano,
  openedAlertaSharedPlan,
  closeAlertaSharedPlan,
  labelDashboardConsumo,
  arrayConsumoTotal
}) {
  return (
    <div
      className={`container-dashboard-fundo-3 fundo-cor-5 ${portalCliente ? 'dashboard-ajuste-portal-cliente' : ''}`}
      id="grafico-simcards-consumo"
    >
      {openedAlertaSharedPlan && (
        <Alerta
          opened={openedAlertaSharedPlan}
          onClick={closeAlertaSharedPlan}
        />
      )}
      <CardHeader
        titulo={
          labelDashboardConsumo ||
          (consumoNoCicloDash === 'default'
            ? 'Consumo nos ciclos'
            : 'Histórico de consumo do plano compartilhado')
        }
        nomeOpcao="consumo"
        portalCliente={portalCliente}
        handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
      />

      <div className="grupo-dash-grafico-pizza-grande">
        {revelarOpcoesConsumo === true && (
          <div
            className={
              cdPlano && showHistoricoConsumo
                ? 'menu-opcoes-dashboard-dispositivos-fundo-consumo'
                : 'menu-opcoes-dashboard-fundo'
            }
          >
            {menuElement}
          </div>
        )}

        {consumoNoCicloDash === 'default' ? (
          portalCliente && chartConsumoData ? (
            <div className="container-simcards-consumo-portal">
              <div className="container-grafico-pizza-consumo-portal">
                <div className="caixa-grafico-pizza-consumo-portal">
                  <ApexChartConsumo
                    series={chartConsumoData}
                    colors={chartFillColors}
                    valueTotals={valueTotals}
                  />
                </div>
              </div>
              <div
                style={{ display: 'none' }}
                className="container-legenda-consumo"
              >
                <LinhaLegendaConsumo
                  key="leg-c1"
                  bgColor="#2196f3"
                  titulo="Total contratado no ciclo"
                  tooltip={tooltipTotalContratado}
                />
                <LinhaLegendaConsumo
                  key="leg-c2"
                  bgColor="#4caf50"
                  titulo="Total Ativo no ciclo"
                  tooltip={tooltipTotalAtivo}
                />
                {filtroOperadora === true && filtroOperadoraPlano === true && (
                  <>
                    <LinhaLegendaConsumo
                      key="leg-c3"
                      bgColor="#FFEB3B"
                      titulo="Previsão de consumo no plano"
                      tooltip={tooltipPrevisaoConsumo}
                    />
                    <LinhaLegendaConsumo
                      key="leg-c4"
                      bgColor="#e53935"
                      titulo="Consumo total no plano"
                      tooltip={tooltipConsumoTotal}
                    />
                  </>
                )}
              </div>
            </div>
          ) : (
            <div className="container-simcards-consumo">
              <div className="container-grafico-pizza-consumo">
                <div className="caixa-grafico-pizza-consumo">
                  <ResponsiveContainer height="100%" width="100%">
                    <BarChart data={arrayConsumoTotal}>
                      {filtroOperadora === true &&
                        filtroOperadoraPlano === true && (
                          <Bar barSize={100} dataKey="value" fill="cor" />
                        )}
                      {filtroOperadora === false &&
                        filtroOperadoraPlano === false && (
                          <Bar barSize={220} dataKey="value" fill="cor" />
                        )}
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
              <div className="container-legenda-consumo">
                <LinhaLegendaConsumo
                  key="leg-c1"
                  bgColor="#2196f3"
                  titulo="Total contratado no ciclo"
                  tooltip={tooltipTotalContratado}
                />
                <LinhaLegendaConsumo
                  key="leg-c2"
                  bgColor="#4caf50"
                  titulo="Total Ativo no ciclo"
                  tooltip={tooltipTotalAtivo}
                />
                {filtroOperadora === true && filtroOperadoraPlano === true && (
                  <>
                    <LinhaLegendaConsumo
                      key="leg-c3"
                      bgColor="#FFEB3B"
                      titulo="Previsão de consumo no plano"
                      tooltip={tooltipPrevisaoConsumo}
                    />
                    <LinhaLegendaConsumo
                      key="leg-c4"
                      bgColor="#e53935"
                      titulo="Consumo total no plano"
                      tooltip={tooltipConsumoTotal}
                    />
                  </>
                )}
              </div>
            </div>
          )
        ) : (
          <div className="container-grafico-historico-consumo">
            {loadingDash ? (
              <LineSkeleton height={275} width={450} visible={loadingDash} />
            ) : (
              <GraficoHistoricoConsumo data={dataHistoricoConsumo} />
            )}
          </div>
        )}
      </div>
    </div>
  )
}
